import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["AlarmTypes"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV2AlarmTypes: build.query<
        GetV2AlarmTypesApiResponse,
        GetV2AlarmTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmTypes`,
          params: {
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
          },
        }),
        providesTags: ["AlarmTypes"],
      }),
      getV2AlarmTypesById: build.query<
        GetV2AlarmTypesByIdApiResponse,
        GetV2AlarmTypesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/v2/AlarmTypes/${queryArg.id}` }),
        providesTags: ["AlarmTypes"],
      }),
      getV2AlarmTypesSubtypes: build.query<
        GetV2AlarmTypesSubtypesApiResponse,
        GetV2AlarmTypesSubtypesApiArg
      >({
        query: () => ({ url: `/v2/AlarmTypes/Subtypes` }),
        providesTags: ["AlarmTypes"],
      }),
      getV2AlarmTypesByAlarmTypeIdSubtypesAndName: build.query<
        GetV2AlarmTypesByAlarmTypeIdSubtypesAndNameApiResponse,
        GetV2AlarmTypesByAlarmTypeIdSubtypesAndNameApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmTypes/${queryArg.alarmTypeId}/Subtypes/${queryArg.name}`,
        }),
        providesTags: ["AlarmTypes"],
      }),
      getV2AlarmTypesByIdSubtypes: build.query<
        GetV2AlarmTypesByIdSubtypesApiResponse,
        GetV2AlarmTypesByIdSubtypesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmTypes/${queryArg.id}/Subtypes`,
          params: {
            name: queryArg.name,
          },
        }),
        providesTags: ["AlarmTypes"],
      }),
      postV2AlarmTypesByIdSubtypes: build.mutation<
        PostV2AlarmTypesByIdSubtypesApiResponse,
        PostV2AlarmTypesByIdSubtypesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmTypes/${queryArg.id}/Subtypes`,
          method: "POST",
          body: queryArg.postAlarmSubtypeDto,
        }),
        invalidatesTags: ["AlarmTypes"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetV2AlarmTypesApiResponse = /** status 200 OK */ AlarmTypeDto[];
export type GetV2AlarmTypesApiArg = {
  orderBy?: string;
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
};
export type GetV2AlarmTypesByIdApiResponse = /** status 200 OK */ AlarmTypeDto;
export type GetV2AlarmTypesByIdApiArg = {
  id: number;
};
export type GetV2AlarmTypesSubtypesApiResponse =
  /** status 200 OK */ AlarmSubtypeDto[];
export type GetV2AlarmTypesSubtypesApiArg = void;
export type GetV2AlarmTypesByAlarmTypeIdSubtypesAndNameApiResponse =
  /** status 200 OK */ AlarmSubtypeDto;
export type GetV2AlarmTypesByAlarmTypeIdSubtypesAndNameApiArg = {
  alarmTypeId: number;
  name: string;
};
export type GetV2AlarmTypesByIdSubtypesApiResponse =
  /** status 200 OK */ AlarmSubtypeDto[];
export type GetV2AlarmTypesByIdSubtypesApiArg = {
  id: number;
  name?: string;
};
export type PostV2AlarmTypesByIdSubtypesApiResponse =
  /** status 201 Created */ AlarmSubtypeDto;
export type PostV2AlarmTypesByIdSubtypesApiArg = {
  id: number;
  postAlarmSubtypeDto: PostAlarmSubtypeDto;
};
export type AlarmTypeDto = {
  alarmTypeId?: number;
  name?: string | null;
  description?: string | null;
  configurationSchema?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type AlarmSubtypeDto = {
  name?: string | null;
  description?: string | null;
  alarmTypeId?: number;
};
export type PostAlarmSubtypeDto = {
  name: string;
  description: string;
};
export const {
  useGetV2AlarmTypesQuery,
  useGetV2AlarmTypesByIdQuery,
  useGetV2AlarmTypesSubtypesQuery,
  useGetV2AlarmTypesByAlarmTypeIdSubtypesAndNameQuery,
  useGetV2AlarmTypesByIdSubtypesQuery,
  usePostV2AlarmTypesByIdSubtypesMutation,
} = injectedRtkApi;
